import { createFileRoute, Link } from '@tanstack/react-router'
import { ForgotPasswordForm } from '@/components/auth/forgot-password-form'
import MkdnLogo from '@/components/ui/mkdn-logo'
import { requireGuest } from '@/lib/route-guards'

export const Route = createFileRoute('/forgot-password')({
  beforeLoad: requireGuest,
  component: ForgotPasswordPage,
  head: () => ({ meta: [{ title: 'Forgot password — mkdn.app' }] }),
})

function ForgotPasswordPage() {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-6 bg-muted p-6 md:p-10">
      <div className="flex w-full max-w-sm flex-col gap-6">
        <Link to="/" className="flex items-center gap-2 self-center font-medium">
          <MkdnLogo size="lg" />
        </Link>
        <ForgotPasswordForm />
      </div>
    </div>
  )
}
